const IDV_TRIGGER_TYPES = {
  bank_account: 'bank_account'
};

const IDV_SESSION_STATUSES = {
  verified: 'verified',
  failed: 'failed'
};

export { IDV_TRIGGER_TYPES, IDV_SESSION_STATUSES };
